module.exports = __webpack_public_path__ + "static/img/num.6cf00b8.png";


//////////////////
// WEBPACK FOOTER
// ./static/funding_cpunk/home/num.png
// module id = kEPM
// module chunks = 1